import React from "react";

export default function Spacer({
    children,
    top,
    right,
    bottom,
    left,
    x,
    y
}) {
    function make_spacer_classes() {
        const classes = [];
        if(x) {
            classes.push(`px-${x}`);
        } else {
            if(right) {
                classes.push(`pr-${right}`);
            }
            if(left) {
                classes.push(`pl-${left}`);
            }
        }
        if (y) {
            classes.push(`py-${y}`);
        } else {
            if(top) {
                classes.push(`pt-${top}`);
            }
            if (bottom) {
                classes.push(`pb-${bottom}`);
            }
        }
        return (
            classes.length > 0
                ? `spacer ${classes.join(" ")}`
                : `spacer`
        );
    }
    return <div className={make_spacer_classes()}>{children}</div>
}